import { SearchEngine } from "./adapters/searchEngine";

import * as search from "./useCases/search";

enum UseCases {
  search = "search",
}

interface Core {
  [UseCases.search]: search.Interactor;
}

type Boundaries = BoundaryMap<Core>;

type Dependencies = { searchEngine: SearchEngine };

function createCore(dependencies: Dependencies): Core {
  return {
    [UseCases.search]: search.createInteractor(dependencies.searchEngine),
  };
}

export type { Core, Boundaries, Dependencies };

export { UseCases, createCore };
